(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.ChemicalsChildrenController = (function(superClass) {
    extend(ChemicalsChildrenController, superClass);

    function ChemicalsChildrenController(scope, transitions, modalInstance, chemicalsService, chemical1, chemicals) {
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.chemicalsService = chemicalsService;
      this.chemical = chemical1;
      this.chemicals = chemicals;
      this.save = bind(this.save, this);
      ChemicalsChildrenController.__super__.constructor.apply(this, arguments);
      this.scope.title = this.chemical.name + ": Add Children";
      this.scope.chemical = this.chemical;
      this.scope.list1 = [];
      this.scope.list2 = this.chemical.children || [];
      this.scope.selected = {
        category: this.chemical.category
      };
      this.scope.categories = ['Fungicide', 'Herbicide', 'Insecticide', 'Growth Regulator', 'Fumigant', 'Defoliant'];
      this.scope.moveRight = (function(_this) {
        return function(items) {
          var chemical, i, idx, item, j, k, len, len1, ref, results;
          results = [];
          for (j = 0, len = items.length; j < len; j++) {
            item = items[j];
            idx = -1;
            ref = _this.scope.list1;
            for (i = k = 0, len1 = ref.length; k < len1; i = ++k) {
              chemical = ref[i];
              if (chemical.id === item.id) {
                idx = i;
              }
            }
            _this.scope.list1.splice(idx, 1);
            results.push(_this.scope.list2.push(item));
          }
          return results;
        };
      })(this);
      this.scope.moveLeft = (function(_this) {
        return function(items) {
          var chemical, i, idx, item, j, k, len, len1, ref, results;
          results = [];
          for (j = 0, len = items.length; j < len; j++) {
            item = items[j];
            idx = -1;
            ref = _this.scope.list2;
            for (i = k = 0, len1 = ref.length; k < len1; i = ++k) {
              chemical = ref[i];
              if (chemical.id === item.id) {
                idx = i;
              }
            }
            _this.scope.list2.splice(idx, 1);
            results.push(_this.scope.list1.push(item));
          }
          return results;
        };
      })(this);
      this.scope.loadAvailableChemicals = (function(_this) {
        return function(category) {
          _this.scope.list1 = _this.chemicals.filter(function(chemical) {
            return chemical.category === category;
          }).filter(function(chemical) {
            return !_this.scope.list2.filter(function(item) {
              return item.id === chemical.id;
            }).length;
          }).filter(function(chemical) {
            var ref;
            return !((ref = chemical.children) != null ? ref.length : void 0);
          }).filter(function(chemical) {
            return chemical.id !== _this.chemical.id;
          });
          return _this.scope.list2 = _this.scope.list2.filter(function(chemical) {
            return chemical.category === category;
          });
        };
      })(this);
      if (this.scope.selected.category) {
        this.scope.loadAvailableChemicals(this.scope.selected.category);
      }
    }

    ChemicalsChildrenController.prototype.save = function() {
      this.chemical.category = this.scope.selected.category;
      this.chemical.children = this.scope.list2;
      if (this.chemical.children.length === 0) {
        this.chemical.max_wind_speed = null;
        this.chemical.mode_of_action = null;
      }
      return this.chemicalsService.saveChemical(this.chemical).then((function(_this) {
        return function(response) {
          return _this.closeWithAlert({
            type: 'success',
            msg: 'Successfully saved children'
          }, response.data);
        };
      })(this))["catch"]((function(_this) {
        return function(response) {
          return _this.setAlert({
            type: 'error',
            msg: 'An error has occurred'
          });
        };
      })(this));
    };

    return ChemicalsChildrenController;

  })(DialogController);

}).call(this);
